export const articleLanguages = ['en', 'es', 'he', 'pt', 'tr', 'fr', 'id', 'it', 'th', 'zh', 'vi', 'ru', 'ja', 'ar'] as const;
export type ArticleLanguage = typeof articleLanguages[number];
export const isArticleLanguage = (value: string): value is ArticleLanguage => (articleLanguages as readonly string[]).includes(value);
export const articleLanguageNames: Record<ArticleLanguage, string> = {
  en: 'English', es: 'Español', he: 'עברית', pt: 'Português', tr: 'Türkçe', fr: 'Français', id: 'Bahasa Indonesia', it: 'Italiano',
  th: 'ไทย', zh: '简体中文', vi: 'Tiếng Việt', ru: 'Русский', ja: '日本語', ar: 'العربية',
};
